import React from "react";

export const UserAccess = ({ data }) => {
  return (
    <div id="about" style={styles.container}>
      <div className="container">
        {/* 🏠 TÍTULO Y DESCRIPCIÓN */}
        <div className="row">
          <div className="col-12 text-center">
            <h1 style={styles.title}>{data?.title || "Loading..."}</h1>
            <p style={styles.subtitle}>
                {data?.paragraph || "Loading..."}
            </p>
          </div>
        </div>

        {/* 🔹 BOTONES CON IMÁGENES */}
        <div className="row">
          {/* BOTÓN USER */}
          <div className="col-xs-12 col-md-6"  style={styles.row}>
            <div
              style={{ ...styles.buttonContainer, backgroundImage: "url('/img/button_user.jpg')" }}
              onClick={() => (window.location.href = "/loginUser?role=user")}
            >
              <div style={styles.overlay}></div>
              <p style={styles.buttonText}>{data?.ButtonA || "Loading..."}</p>
            </div>
          </div>

          {/* BOTÓN NOK */}
          <div className="col-xs-12 col-md-6"  style={styles.row}>
            <div
              style={{ ...styles.buttonContainer, backgroundImage: "url('/img/button_nok.jpg')" }}
              onClick={() => (window.location.href = "/loginUser?role=nok")}
            >
              <div style={styles.overlay}></div>
              <p style={styles.buttonText}>{data?.ButtonB || "Loading..."}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// 🎨 ESTILOS
const styles = {
  container: {
    position: "relative",
    overflow: "hidden",
    padding: "60px 0",
    backgroundColor: "#f4f4f4",
  },
  row: {
    marginTop: "50px"
  },
  title: {
    fontSize: "32px",
    fontWeight: "bold",
    color: "#0A3A2C",
  },
  subtitle: {
    fontSize: "18px",
    color: "#555",
    marginBottom: "40px",
  },
  buttonContainer: {
    position: "relative",
    width: "100%",
    height: "250px",
    backgroundSize: "cover",
    backgroundPosition: "center",
    borderRadius: "12px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
    transition: "transform 0.3s ease-in-out",
  },
  overlay: {
    position: "absolute",
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)", // Overlay negro con opacidad
  },
  buttonText: {
    position: "relative",
    color: "#fff",
    fontSize: "24px",
    fontWeight: "bold",
    zIndex: 2, // Para estar por encima del overlay
    textTransform: "uppercase",
  },
};

// ✨ AGREGAR EFECTO HOVER Y ACTIVE DESDE CSS
const styleSheet = document.createElement("style");
styleSheet.innerHTML = `
  .row div:hover .buttonContainer,
  .row div:active .buttonContainer {
    transform: scale(1.05);
  }
`;
document.head.appendChild(styleSheet);

export default UserAccess;
